var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46241 7.52975e-07H0.546908C0.389662 -0.000296686 0.245504 0.0875466 0.173623 0.227442C0.100751 0.36922 0.113541 0.539949 0.206639 0.669434L3.4729 5.2706C3.47399 5.27218 3.47518 5.27367 3.47627 5.27526C3.59495 5.43548 3.6591 5.62951 3.65949 5.82899V9.58027C3.6588 9.69141 3.70242 9.7981 3.78075 9.87692C3.85908 9.95574 3.96556 9.99996 4.0766 9.99996C4.13311 9.99996 4.18893 9.98865 4.24108 9.96704L6.07647 9.26717C6.24096 9.217 6.35012 9.06184 6.35012 8.87495V5.82899C6.35041 5.6296 6.41466 5.43548 6.53324 5.27526C6.53433 5.27367 6.53552 5.27218 6.53661 5.2706L9.80277 0.669236C9.89587 0.53985 9.90866 0.36922 9.83579 0.227442C9.76391 0.0875466 9.61975 -0.000296686 9.46241 7.52975e-07ZM6.12396 4.97455C5.94154 5.22212 5.84289 5.52144 5.84229 5.82899V8.81328L4.16712 9.45198V5.82899C4.16653 5.52144 4.06788 5.22212 3.88535 4.97455L0.714365 0.507628H9.29505L6.12396 4.97455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.35598d2a5b684cfe11c7961818d26a4e.svg";
export { ForwardRef as ReactComponent };